import { Methods } from '../../api/methods.js';
import type { ParsedArgs } from '../args.js';
import { booleanFlag, flag, flagAll, numberFlag } from '../args.js';
import { CliError, ExitCode } from '../errors.js';
import type { CommandResult } from '../output.js';
import { pickDefined, request, requireConfirmation } from './common.js';

export async function playtimeCommand(args: ParsedArgs): Promise<CommandResult> {
  const action = args.positionals[1] ?? 'status';
  if (action === 'status') return request(args, Methods.Playtime);
  if (action !== 'limits') {
    throw new CliError(`Unknown playtime action "${action}"`, ExitCode.Usage);
  }
  const limitsAction = args.positionals[2] ?? 'get';
  if (limitsAction === 'get') return request(args, Methods.PlaytimeLimits);
  if (limitsAction === 'update') {
    const warnings = flagAll(args.flags, 'warning');
    const params = pickDefined({
      enabled: booleanFlag(args.flags, 'enabled'),
      daily: flag(args.flags, 'daily'),
      session: flag(args.flags, 'session'),
      sessionReset: flag(args.flags, 'session-reset'),
      warnings: warnings.length > 0 ? warnings : undefined,
      retention: numberFlag(args.flags, 'retention'),
    });
    if (!params) {
      throw new CliError('playtime limits update requires at least one field', ExitCode.Usage);
    }
    requireConfirmation(args, 'Updating playtime limits requires confirmation');
    return request(args, Methods.PlaytimeLimitsUpdate, params);
  }
  throw new CliError(`Unknown playtime limits action "${limitsAction}"`, ExitCode.Usage);
}
